import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { navList } from '../../../../constants/constants';
import { CollapseChangeService } from '../../../../shared/collapse-change.service';
import { NavIconService } from '../../Services/NavIcon.service';
import { IconDefinition } from '@fortawesome/angular-fontawesome';


@Component({
  selector: 'app-sider',
  templateUrl: './sider.component.html',
  styleUrls: ['./sider.component.scss']
})
export class SiderComponent implements OnInit {
  @Input() public isCollapsed: boolean = false;
  @Output() public onNavigate = new EventEmitter();

  public currentRoute: string = '';
  public navigationList: any[] = navList;


  constructor(
    private router: Router,
    private collapseService: CollapseChangeService,
    private navIconService: NavIconService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit(): void {
  }

  onNavigation = (tab: string) => {
    this.onNavigate.emit(tab);
  }


  // onNavigation1(item: string): void {
  //   // Handle the navigation based on the clicked submenu item
  //   if (item === 'configure-algorithm') {
  //     // Handle the 'Configure Algorithm' submenu item click
  //     // Add your logic here
  //     this.collapseService.setIsCollapsed(false);
  //   } else if (item === 'configure-training') {
  //     // Handle the 'Configure Training' submenu item click
  //     // Add your logic here
  //     this.collapseService.setIsCollapsed(false);
  //   }
  // }
  
  getIcon(iconName: string): IconDefinition {
    return this.navIconService.getIcon(iconName);
  }

  change(value: boolean): void {
  }
}
